import React, { useState, useEffect } from 'react';
import { fetchLogisticaPropiaApi, updateLogisticaPropiaApi } from "../../api/axios";
import BigSpinner from "../General/BigSpinner";
import MiniSpinner from "../General/MiniSpinner";
import { toast } from "react-toastify";

export default function LogisticaPropia({ idSeller, userType }) {
  const isSeller = userType.isSellerAdmin || userType.isSeller;
  const [isFetchingData, setIsFetchingData] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [logisticaPropia, setLogisticaPropia] = useState([]);
  const [zonas, setZonas] = useState([
    { id: 1, name: "amba", enabled: false, envioGratis: false },
    { id: 2, name: "interior", enabled: false, envioGratis: false },
    { id: 3, name: "patagonia", enabled: false, envioGratis: false }
  ]);

  useEffect(() => {
    let response = fetchLogisticaPropiaApi({ idSeller });
    response.then(res => {
      const { escalas, envioGratisZona } = res;
      let updateZonas = [];

      for (let i = 0; i < zonas.length; i++) {
        let zona = zonas[i];
        if (envioGratisZona[zona.name]) zona.envioGratis = true;
        for (let j = 0; j < escalas.length; j++) {
          if (escalas[j][zona.name] !== null) {
            zona.enabled = true;
            break;
          }
        }
        updateZonas.push(zona);
      }
      setLogisticaPropia(escalas);
      setZonas(updateZonas);
    }).catch(err => {
      (err.response.data.errores)
        ? err.response.data.errores.forEach(error => toast.warn(error))
        : toast.error("Los datos de logística no pudieron ser obtenidos");
    }).finally(() => {
      setIsFetchingData(false);
    });
  }, []);

  const handleChangeZona = (e, zona) => {
    const { name } = e.target;
    setZonas((prevState) => {
      const updatedItems = prevState.map((item) => {
        if (item.name === zona) {
          const updatedItem = { ...item, [name]: !item[name] };
          if (name === "enabled") {
            updatedItem.envioGratis = updatedItem.enabled ? item.envioGratis : false;
          } else if (name !== "enabled" && !updatedItem.enabled) {
            return item;
          }
          if (updatedItem.envioGratis) {
            toast.warn("Solo tomara envío gratis los productos que tengan cargado costo y promesa de entrega, de lo contrario se omitirá el envió propio pasando por envío externo");
          };
          return updatedItem;
        }
        return item;
      });
      return updatedItems;
    });
  };

  const handleChangeEscala = (e, escalaId, zona) => {
    const { name, value } = e.target;

    if (value.length > e.target.getAttribute('maxLength')) return;
    const valueParsed = name === "costo" ? parseFloat(value) : parseInt(value);

    setLogisticaPropia(prevState => {
      const updatedItems = prevState.map((escala) => {
        if (escala.idEscala === escalaId) {
          return { ...escala, [zona]: { ...escala[zona], [name]: valueParsed } };
        } else {
          return escala;
        }
      });
      return updatedItems;
    })
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setIsUpdating(true);
    let updatedZonas = [];

    for (let i = 0; i < zonas.length; i++) {
      const zona = zonas[i];
      let updatedEscalas = [];

      if (zona.enabled) {
        for (let j = 0; j < logisticaPropia.length; j++) {
          const logistica = logisticaPropia[j];

          const costo = logistica[zona.name]?.costo || null;
          const diasEntrega = logistica[zona.name]?.diasEntrega || null;

          if (diasEntrega && !costo) {
            toast.warn("Falta completar un costo");
            setIsUpdating(false);
            return;
          }

          if (costo && !diasEntrega) {
            toast.warn("Falta completar una promesa de entrega");
            setIsUpdating(false);
            return;
          }

          const escala = {
            idEscala: logistica.idEscala,
            entrega: { costo: costo, diasEntrega: diasEntrega }
          }

          updatedEscalas.push(escala);
        }
      }

      const zonaUpdated = {
        idZona: zona.id,
        habilitada: zona.enabled,
        envioGratis: zona.envioGratis,
        escalas: updatedEscalas
      }
      updatedZonas.push(zonaUpdated);
    }

    const req = updateLogisticaPropiaApi({ idSeller: parseInt(idSeller), zonas: updatedZonas });
    req.then(res => {
      toast.success("Logística propia actualizada");
    }).catch(err => {
      (err.response.data.errores)
        ? err.response.data.errores.forEach(error => toast.error(error))
        : toast.error("La logística propia no pudo ser actualizada");
    }).finally(() => {
      setIsUpdating(false);
    });
  };

  return (
    <div className="row card align-items-center justify-content-center">
      {isFetchingData ? <BigSpinner /> :
        <div className="animated fadeIn">
          <div className="table-responsive">
            <table className="table border-table">
              <thead>
                <tr>
                  <th rowSpan={2} style={{ width: "16%" }}><small></small></th>
                  {zonas.map((zona, index) => {
                    return (
                      <th key={index} colSpan={2} style={{ width: "28%" }}>
                        <small>Habilitar Log. Propia</small>
                        <span className="form-switch">
                          <input
                            name="enabled"
                            type="checkbox"
                            checked={zona.enabled}
                            className="form-check-input ms-2 mt-1"
                            onChange={(e) => handleChangeZona(e, zona.name)}
                            disabled={!isSeller}
                          />
                        </span>
                      </th>
                    )
                  })}
                </tr>
                <tr>
                  {zonas.map((zona, index) => {
                    return (
                      <th key={index} colSpan={2}>
                        <small>Envío Gratis</small>
                        <span className="form-switch">
                          <input
                            name="envioGratis"
                            type="checkbox"
                            checked={zona.envioGratis}
                            className="form-check-input ms-2 mt-1"
                            onChange={(e) => handleChangeZona(e, zona.name)}
                            disabled={!isSeller}
                          />
                        </span>
                      </th>
                    )
                  })}
                </tr>
                <tr>
                  <th rowSpan={2}><small>Escala</small></th>
                  <th colSpan={2}><small>Amba</small></th>
                  <th colSpan={2}><small>Interior</small></th>
                  <th colSpan={2}><small>Patagonia</small></th>
                </tr>
                <tr>
                  <th><small>Costo</small></th>
                  <th><small>Promesa Entrega</small></th>
                  <th><small>Costo</small></th>
                  <th><small>Promesa Entrega</small></th>
                  <th><small>Costo</small></th>
                  <th><small>Promesa Entrega</small></th>
                </tr>
              </thead>
              <tbody>
                {logisticaPropia.map((escala, index) => {
                  return (
                    <tr key={index} className="hover-background-color">
                      <td><small>{escala?.descripcion}</small></td>
                      {zonas.map((zona, index) => {
                        return (
                          <React.Fragment key={index}>
                            {zona.enabled ?
                              <>
                                <td>
                                  <small className="d-inline me-2">$</small>
                                  <input
                                    type="number"
                                    name="costo"
                                    value={escala[zona.name]?.costo || ""}
                                    min="0"
                                    maxLength={8}
                                    className="form-control d-inline w-75"
                                    onChange={(e) => handleChangeEscala(e, escala.idEscala, zona.name)}
                                    disabled={!isSeller}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    name="diasEntrega"
                                    value={escala[zona.name]?.diasEntrega || ""}
                                    min="0"
                                    maxLength={3}
                                    className="form-control w-25 d-inline text-center"
                                    onChange={(e) => handleChangeEscala(e, escala.idEscala, zona.name)}
                                    disabled={!isSeller}
                                  />
                                  <small className="d-inline me-2">
                                    {escala[zona.name]?.diasEntrega ? escala[zona.name]?.diasEntrega === 1
                                      ? "Mismo día" : "Días Hábiles" : ""
                                    }
                                  </small>
                                </td>
                              </>
                              :
                              <>
                                <td></td>
                                <td></td>
                              </>
                            }
                          </React.Fragment>
                        )
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      }
      <div className="col-auto my-2">
        {isUpdating && <MiniSpinner />}
        {isSeller &&
          <button
            className="btn btn-sm background-rojo-megatone mx-2"
            onClick={onSubmit}
            disabled={isUpdating}
          >
            Actualizar Logística
          </button>
        }
      </div>
    </div>
  )
}